import React, { useState } from 'react'

import {
  Dialog,
  IconButton,
  Box,
  DialogContent,
  Typography,
  Grid,
} from '@mui/material';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import CloseIcon from '@mui/icons-material/Close';

const VideoThumbnailSmall = ({
  videoUrl,
  thumbnailUrl,
  title,
  width = '100%',
  height = '100%'
}) => {
  const [open, setOpen] = useState(false);

  // Extract video ID from YouTube URL
  const getYouTubeVideoId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url?.match(regExp);
    return (match && match[2].length === 11) ? match[2] : '';
  };

  // Get thumbnail URL if not provided
  const defaultThumbnail = `https://img.youtube.com/vi/${getYouTubeVideoId(videoUrl)}/0.jpg`;

  return (
    <Grid sx={{ height: '100%' }}>
      {/* Thumbnail Container */}
      <Box
        sx={{
          position: 'relative',
          width,
          height,
          cursor: 'pointer',
        }}
        onClick={() => setOpen(true)}
      >
        {/* Thumbnail Image */}
        <Box
          component="img"
          src={thumbnailUrl || defaultThumbnail}
          alt={title || 'Video thumbnail'}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '8px',
          }}
        />

        {/* Play Button Overlay */}
        <PlayCircleIcon
          className="play-icon"
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '64px',
            color: 'white',
            opacity: 0.9,
            transition: 'all 0.2s ease-in-out',
            filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.5))',
          }}
        />
      </Box>

      {/* Video Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent
          sx={{
            padding: 0,
            backgroundColor: 'black',
            position: 'relative',
            paddingTop: '56.25%', // 16:9 Aspect Ratio
            overflow: 'hidden'
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: 'absolute',
              top: '-36px',
              right: '-36px',
              color: 'orange',
              zIndex: 1000,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* YouTube Embed */}
          <iframe
            src={`https://www.youtube.com/embed/${getYouTubeVideoId(videoUrl)}?autoplay=1`}
            title={title || "YouTube video player"}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
          />
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default VideoThumbnailSmall;